import script from "./RubricQueryParameters.vue?vue&type=script&setup=true&lang=js"
export * from "./RubricQueryParameters.vue?vue&type=script&setup=true&lang=js"

import "./RubricQueryParameters.vue?vue&type=style&index=0&id=18b47a82&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b47a82"]])

export default __exports__